export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZES = [5, 10, 20];